import React, {useState} from 'react';
import {Avatar, Box, Container, Grid, Typography} from '@mui/material';
import {useMutation} from '@apollo/client';
import {useForm} from 'react-hook-form';
import generateValidators from 'generators/validation/generateValidators';
import GeneratedInput from 'generators/input/GeneratedInput';
import Link from 'components/Link';
import {yupResolver} from '@hookform/resolvers/yup';
import Logo from 'public/logo.svg';
import {useRouter} from 'next/router';
import {LoadingButton} from '@mui/lab';
import {EMAIL_FIELDS, PASSWORD_FIELDS} from 'views/auth/resetPassword/fields';
import {INIT_RESET_PASSWORD} from 'graphql/auth/resetPassword/initResetPassword';
import {RESET_PASSWORD} from 'graphql/auth/resetPassword/resetPassword';


const Login = () => {
    const {query, push} = useRouter();
    const {token} = query;

    const [loading, setLoading] = useState(false);
    const {control, handleSubmit, setError, formState: {errors}} = useForm({
        resolver: yupResolver(generateValidators(token ? PASSWORD_FIELDS : EMAIL_FIELDS))
    });
    const [initResetPassword] = useMutation(INIT_RESET_PASSWORD);
    const [resetPassword] = useMutation(RESET_PASSWORD);

    const onInitReset = (data) => {
        setLoading(true);
        initResetPassword({
            variables: {email: data.email}
        }).then(res => {
            setLoading(false);
        }).catch(err => {
            setError('email', {type: 'invalid'});
            setLoading(false);
        });
    };

    const onReset = (data) => {
        setLoading(true);
        resetPassword({
            variables: {newPassword: data.password, token}
        }).then(res => {
            push('/auth/login');
        }).catch(err => {
            setError('password', {type: 'invalid'});
            setError('confirmPassword', {type: 'invalid', message: 'Ошибка попробуйте еще раз'});
            setLoading(false);
        });
    };

    return (
        <Container component='main' maxWidth='xs'>
            {!token ?
                <Box sx={{marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <Avatar sx={{m: 1, bgcolor: 'transparent'}}>
                        <img src={Logo} alt={'phoenix-logo'} style={{width: '100%'}} />
                    </Avatar>
                    <Typography variant='h4'>Восстановление пароля</Typography>
                    <Typography variant='body2' mt={1} textAlign={'center'}>Мы отправим вам письмо с инструкцией для
                        восстановления пароля</Typography>
                    <Box component='form' onSubmit={handleSubmit(onInitReset)} noValidate sx={{mt: 1}}>
                        {EMAIL_FIELDS.map(input => <GeneratedInput {...{input, control}} />)}
                        <LoadingButton loading={loading} type='submit'
                                       fullWidth variant='contained' sx={{mt: 3, mb: 2}}>
                            Отправить
                        </LoadingButton>
                    </Box>
                </Box>
                :
                <Box sx={{marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <Avatar sx={{m: 1, bgcolor: 'transparent'}}>
                        <img src={Logo} alt={'phoenix-logo'} style={{width: '100%'}} />
                    </Avatar>
                    <Typography variant='h4'>Новый пароль</Typography>
                    <Typography variant='body2' mt={1} textAlign={'center'}>Введите новый пароль</Typography>
                    <Box component='form' onSubmit={handleSubmit(onReset)} sx={{mt: 1}}>
                        {PASSWORD_FIELDS.map(input => <GeneratedInput {...{input, control}} />)}
                        <LoadingButton loading={loading} type='submit'
                                       fullWidth variant='contained'
                                       sx={{mt: 3, mb: 2}}>
                            Изменить пароль
                        </LoadingButton>
                        <Grid container>
                            <Grid item xs>
                                <Link href={'/auth/reset-password'} variant='body2' underline={'none'}>
                                    Отправить еще раз
                                </Link>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            }
        </Container>
    );
};

export default Login;
